import React from 'react';

import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const ActivityCompleted = () => {
    const notify = () => {
        toast.success('Congratulation!!! you have done all of your activities', {
            position: toast.POSITION.TOP_CENTER
        });
    };

    return (
        <div>
            <button onClick={notify} className=" mt-10 bg-lime-500 text-white font-bold w-full rounded-lg py-2">
                Activity Completed
            </button>
            <ToastContainer></ToastContainer>
        </div>
    );
};

export default ActivityCompleted;